import { cn } from "@/libs/utils/tailwind/cn";
import { SlotsToClasses } from "@nextui-org/react";

export default function OurMissionSection({
  className,
  classNames,
}: OurMissionSectionProps) {
  return (
    <section
      className={cn(classNames?.base, className)}>
      <div className={cn(classNames?.container)}>
        <h2 className="mb-8 text-foreground text-center text-xl sm:text-3xl font-semibold tracking-tight">
          Our Mission
        </h2>
        <p className="mx-auto max-w-[954px] text-center text-2xl sm:leading-tight font-medium text-foreground sm:text-4xl lg:text-[46px]">
          We connect homeowners with trusted local pros — fast — making it
          simple to compare<br />
          <span className="text-foreground/50">
            options, choose the right contractor, and get the job done with confidence.
          </span>
        </p>
        <div className="grid mx-auto mt-8 sm:mt-20 max-w-6xl gap-12 grid-cols-3">
          {STATS.map(({ title, description }, key) => (
            <div key={key} className="flex flex-col items-center gap-3 text-center">
              <h3 className="text-2xl text-foreground sm:text-7xl font-medium">
                {title}
              </h3>

              <p className="text-sm sm:text-2xl text-default-600 font-light leading-tight">
                {description}
              </p>
            </div>
          ))}
        </div >
      </div>
    </section>
  );
}

const STATS = [
  {
    title: "20+",
    description: "Years experience",
  },
  {
    title: "13M+",
    description: "Homeowners served",
  },
  {
    title: "10K+",
    description: "Contractor partners",
  },
];

interface OurMissionSectionProps {
  className?: string;
  classNames?: SlotsToClasses<"base" | "container">;
}
